import * as signalR from "@microsoft/signalr"
const url = "http://192.9.200.25:8018/single-login"

function signal(accessTokenFactory: string) {
  return new signalR.HubConnectionBuilder()
    .withUrl(url, {
      skipNegotiation: true,
      transport: signalR.HttpTransportType.WebSockets,
      accessTokenFactory: () => accessTokenFactory
    })
    .configureLogging(signalR.LogLevel.Information)
    .build()
}
export default signal
